import { render, staticRenderFns } from "./AdminSessionStats.vue?vue&type=template&id=2cff47a9&scoped=true"
import script from "./AdminSessionStats.vue?vue&type=script&lang=ts"
export * from "./AdminSessionStats.vue?vue&type=script&lang=ts"
import style0 from "./AdminSessionStats.vue?vue&type=style&index=0&id=2cff47a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff47a9",
  null
  
)

export default component.exports